import React, { FC, useCallback, useMemo } from 'react';
import { EFilterType, IFilterComponentProps } from './filter.types';
import FilterAutocompleteSelection, {
  IFilterAutocompleteSelectItem,
} from 'Components/Filter/FilterAutocompleteSelection';
import { COUNTRIES } from 'utils/countries.utils';
import CountryRiskLevel from 'DesignSystem/DataDisplay/CountryRiskLevel/CountryRiskLevel';
import { Box } from '@mui/material';

const CountriesFilter: FC<IFilterComponentProps<EFilterType.COUNTRIES>> = ({
  value,
  label,
  multiple,
  onChange,
}) => {
  const countryItems: IFilterAutocompleteSelectItem[] = useMemo(() => {
    return COUNTRIES.map(country => ({
      id: country.code,
      title: country.label,
      endAdornment: country.riskLevel ? (
        <Box ml={1}>
          <CountryRiskLevel riskLevel={country.riskLevel} />
        </Box>
      ) : undefined,
    }));
  }, []);

  const handleSelectionChange = useCallback(
    (selectedIds: string[] | string | undefined) => {
      const ids = Array.isArray(selectedIds) ? selectedIds : selectedIds ? [selectedIds] : [];
      onChange(ids);
    },
    [onChange]
  );

  return (
    <FilterAutocompleteSelection
      label={label ?? 'Countries'}
      placeholder="All countries"
      closeAfterSelection
      enableAddNewItem
      multiple={multiple}
      itemName="country"
      items={countryItems}
      selected={value ?? undefined}
      onSelectionChange={handleSelectionChange}
    />
  );
};

export default CountriesFilter;
